import { CBConstants } from '../react-components/StatsbidragContactBlock/StatsbidragContactBlock.constants';

export const STR_FIELD = '__field';
export const STR_CC = '__cc';
export const STR_C = CBConstants.ContactFormPrefix;

export function nameIsEpiFormField(name: string): boolean {
  return name.startsWith(STR_FIELD) || name.startsWith(STR_CC) || name.startsWith(STR_C);
}

export function stringContainsOnlyWhitelist(inputString: string, whitelist: string[]): boolean {
  return [...inputString].every(char => {
    return whitelist.includes(char);
  });
}

export function charCountInString(inputString: string, char: string): number {
    let count = 0;
    [...inputString].forEach(s => {
      if (s === char) count++;
    });
    return count;
}